// extracted by mini-css-extract-plugin
export default {"twoWayResponseBody":"TwoWayFormResponse_twoWayResponseBody__2d5Vj"};